if (typeof DynaBase_Overlay == 'undefined') {
    var DynaBase_Overlay =
    {
        /**
         * Zobrazeni overlay
         */
        show: function () {
            $('#overlay').addClass('active');
            $('body').addClass('overlay-active');
        },

        /**
         * Skryti overlay
         */
        hide: function () {
            $('#overlay').removeClass('active');
            $('body').removeClass('overlay-active');
        }
    }
}
